<div class="card">
  <h5 class="card-header flex-between">
    <div class="flex-start">
      <button class="btn btn-light" (click)="onBack()">
        <i class="fa fa-angle-left" aria-hidden="true"></i>
        Pillars
      </button>
      <span>
        {{ selectedPillar?.pillar_name }}
      </span>
    </div>
  </h5>

  <div class="card-body">
    <div class="alert alert-danger" *ngIf="answersError">
      {{ answersError }}
    </div>
    <div class="alert alert-danger" *ngIf="!answersError && answerSaveError">
      {{ answerSaveError }}
    </div>

    <div class="text-center py-3" *ngIf="answersLoading && questions.length == 0">
      <img src="assets/img/loading_2.svg" alt="loading answers" class="loader-icon" />
    </div>

    <div class="quiz-app" *ngIf="questions.length > 0; else noQuestions">
      <ng-container *ngIf="showSidebar">
        <div class="pillers_container position-relative">
          <div class="padding-center">PILLARS</div>

          <ng-container *ngIf="pillarsLoading">
            <div class="piller loading_shadhow mar-bottom-12">
              <span class="padding-100"></span>
            </div>
            <div class="piller loading_shadhow mar-bottom-12">
              <span class="padding-100"></span>
            </div>
            <div class="piller loading_shadhow mar-bottom-12">
              <span class="padding-100"></span>
            </div>
          </ng-container>

          <ng-container *ngIf="!pillarsLoading">
            <div
              class="piller"
              *ngFor="let pillar of sidebarPillars"
              [ngClass]="{ selected: isSidebarPillarSelected(pillar) }"
              (click)="onSidebarPillarSelect(pillar)"
            >
              <span>{{ getPillarDisplayName(pillar) }}</span>
              <span class="color-radius-20">{{ getPillarAnsweredLabel(pillar) }}</span>
            </div>

            <div class="center" *ngIf="sidebarPillars.length == 0">No pillars found</div>
          </ng-container>

          <div class="hideSidebar" (click)="showSidebar = false">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!showSidebar">
        <div class="hidden_sidebar" (click)="showSidebar = true">
          <i class="fa fa-bars mar-top-10" aria-hidden="true"></i>
        </div>
      </ng-container>

      <div class="questions_container">
        <div class="quiz_actions">
          <button class="btn btn-light" *ngIf="currentQuestionIndex > 0" (click)="prev()">
            <div class="flex-start">
              <span><i class="fa fa-angle-left" aria-hidden="true"></i></span>
              <span>Prev</span>
            </div>
          </button>
          <button class="btn btn-light" *ngIf="currentQuestionIndex < questions.length - 1" (click)="next()">
            <div class="flex-start">
              <span>Next</span>
              <span><i class="fa fa-angle-right" aria-hidden="true"></i></span>
            </div>
          </button>
          <ng-container *ngIf="!answerSaving">
            <button class="btn btn-light" (click)="onSaveCurrentQuestion()">
              Save
            </button>
          </ng-container>
          <ng-container *ngIf="answerSaving">
            <img src="assets/img/loading_2.svg" alt="saving answer" class="wid-14" />
          </ng-container>
        </div>

        <div class="question" *ngIf="currentQuestion">
          <div class="question_title flex-start flex-top">
            <span class="nowrap">{{ currentQuestion.nav_order || currentQuestionIndex + 1 }}.</span>
            <span>
              {{ currentQuestion.question }}
              <span *ngIf="currentQuestion.question_type" class="question_type">
                {{ currentQuestion.question_type }}
              </span>
            </span>
          </div>

          <div class="option_description q-description" *ngIf="currentQuestion.description">
            {{ currentQuestion.description }}
          </div>

          <div class="q-meta" *ngIf="currentQuestion.answer_value || currentQuestion.mode || currentQuestion.confidence">
            <span class="q-pill" *ngIf="currentQuestion.answer_value">
              Answer: {{ currentQuestion.answer_value }}
            </span>
            <span class="q-pill" *ngIf="currentQuestion.mode">
              Mode: {{ currentQuestion.mode }}
            </span>
            <span class="q-pill" *ngIf="currentQuestion.confidence">
              Confidence: {{ currentQuestion.confidence }}
            </span>
          </div>

          <div class="options_container">
            <div
              class="option hover-option"
              [ngClass]="{
                selected_option_contaniner: isOptionSelected(currentQuestion, option),
                'disabled-option': answerSaving
              }"
              (click)="onOptionToggle(currentQuestion, option, $event)"
              *ngFor="let option of currentQuestion.options; let j = index"
            >
              <div class="pointer-none">
                <input
                  autocomplete="off"
                  type="checkbox"
                  [checked]="isOptionSelected(currentQuestion, option)"
                  *ngIf="option.label != 'None of the above.'"
                />
                <input
                  autocomplete="off"
                  type="radio"
                  [checked]="isOptionSelected(currentQuestion, option)"
                  *ngIf="option.label == 'None of the above.'"
                />
              </div>
              <div class="flex-1">
                <div class="option_text">
                  {{ option.label }}
                </div>
                <div class="option_description" *ngIf="option.description">
                  {{ option.description }}
                </div>
              </div>
            </div>
          </div>

          <div class="q-edit">
            <div class="q-edit-row">
              <label class="q-edit-label">Answer</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                [(ngModel)]="currentQuestion.answer_value"
                (ngModelChange)="onQuestionFieldChange(currentQuestion)"
                [disabled]="answerSaving"
              />
            </div>
            <div class="q-edit-row">
              <label class="q-edit-label">Reason</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                [(ngModel)]="currentQuestion.reason"
                (ngModelChange)="onQuestionFieldChange(currentQuestion)"
                [disabled]="answerSaving"
              />
            </div>
            <div class="q-edit-row">
              <label class="q-edit-label">User Notes</label>
              <textarea
                rows="3"
                class="form-control"
                [(ngModel)]="currentQuestion.user_notes"
                (ngModelChange)="onQuestionFieldChange(currentQuestion)"
                [disabled]="answerSaving"
              ></textarea>
            </div>
            <div class="q-unsaved" *ngIf="currentQuestion?.__dirty && !answerSaving">
              Unsaved changes
            </div>
          </div>
        </div>

        <div class="quiz_actions" *ngIf="currentQuestion">
          <button class="btn btn-light" *ngIf="currentQuestionIndex > 0" (click)="prev()">
            <div class="flex-start">
              <span><i class="fa fa-angle-left" aria-hidden="true"></i></span>
              <span>Prev</span>
            </div>
          </button>
          <button class="btn btn-light" *ngIf="currentQuestionIndex < questions.length - 1" (click)="next()">
            <div class="flex-start">
              <span>Next</span>
              <span><i class="fa fa-angle-right" aria-hidden="true"></i></span>
            </div>
          </button>
          <ng-container *ngIf="!answerSaving">
            <button class="btn btn-light" (click)="onSaveCurrentQuestion()">
              Save
            </button>
          </ng-container>
          <ng-container *ngIf="answerSaving">
            <img src="assets/img/loading_2.svg" alt="saving answer" class="wid-14" />
          </ng-container>
        </div>
      </div>

      <div class="question_switcher">
        <div class="question_slider">
          <div class="mar-left">QUESTIONS</div>
          <div
            *ngFor="let question of questions; let i = index"
            class="question_number"
            (click)="changeQuestion(i)"
          >
            <div class="question_no font-bold">
              <span
                [ngClass]="{
                  current_question: i == currentQuestionIndex,
                  answerd_question: isQuestionAnswered(question) && i != currentQuestionIndex,
                  un_answerd_question: !isQuestionAnswered(question) && i != currentQuestionIndex
                }"
              >
                {{ i + 1 }}
              </span>
            </div>
            <div class="question_switcher_text_container white-now">
              <span
                class="question_switcher_text"
                title="{{ question.question || ('Question ' + (i + 1)) }}"
                [ngStyle]="{
                  'font-weight': i == currentQuestionIndex ? 'bold' : 'normal'
                }"
              >
                {{ question.question || ("Question " + (i + 1)) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noQuestions>
      <div class="center" *ngIf="!answersLoading">No questions found</div>
    </ng-template>
  </div>
</div>
